/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {CatalogItemFacts} from "./catalogItemFacts.zod";
import {SelectedSupplierFacts} from "./selectedSupplierFacts.zod";

export const EvaluatedCatalogBlock = zod
  .unknown()
  .and(zod.unknown())
  .and(
    zod.object({
      chapterId: zod.uuid(),
      blockId: zod.uuid(),
      soldCatalogItem: zod.union([CatalogItemFacts, zod.null()]),
      selectedSupplierOffers: zod.array(SelectedSupplierFacts),
      quantity: zod
        .number()
        .nullable()
        .describe(
          "Effective sold quantity in new current evaluation: one for authored null, otherwise the supplied numeric value. Invalid explicit values do not produce prices. Historical captured facts stay unchanged. Authored display quantity remains separately under content.",
        ),
      priceProtected: zod.boolean(),
      costAvailability: zod.enum(["AVAILABLE", "RESTRICTED", "UNAVAILABLE"]),
      unitSupplierCost: zod
        .number()
        .optional()
        .describe(
          "Exact weighted sold-root unit supplier cost in enclosing Currency, summing distinct SIMPLE-leaf path weights. Never divide a rounded amount to reconstruct it.",
        ),
      supplierCost: zod
        .number()
        .optional()
        .describe(
          "Exact unrounded extended cost in enclosing Currency, including effective sold quantity, not prematurely rounded Money.",
        ),
    }),
  );

export type EvaluatedCatalogBlock = zod.input<typeof EvaluatedCatalogBlock>;
export type EvaluatedCatalogBlockOutput = zod.output<typeof EvaluatedCatalogBlock>;
